import AnalyzePerformanceFooterAction from "./AnalyzePerformanceFooterAction";
import "./AnalyzePerformanceFooterAction.scss";

export default AnalyzePerformanceFooterAction